import { Path } from "../enums/path.enum";

export const sidebarVoices = [
    {
      label: 'Attività cliente',
      url: Path.ATTIVITA_CLIENTE,
      title: 'Attività cliente',
      isActive: false,
    },
    {
      label: 'Attività corriere',
      url: Path.ATTIVITA_CORRIERE,
      title: 'Attività corriere',
      isActive: false,
    },
    {
      label: 'Magazzino pacchi',
      url: Path.MAGAZZINO_PACCHI,
      title: 'Magazzino pacchi',
      isActive: false,
    },
    {
      label: 'Magazzino materiali',
      url: Path.MAGAZZINO_MATERIALI,
      title: 'Magazzino materiali',
      isActive: false,
    }
]

export const sidebarVoicesNoMagazzino = [
  {
    label: 'Attività cliente',
    url: Path.ATTIVITA_CLIENTE,
    title: 'Attività cliente',
    isActive: false,
  },
  {
    label: 'Attività corriere',
    url: Path.ATTIVITA_CORRIERE,
    title: 'Attività corriere',
    isActive: false,
  },
  {
    label: 'Magazzino pacchi',
    url: Path.MAGAZZINO_PACCHI,
    title: 'Magazzino pacchi',
    isActive: false,
  },
]


